import get from "lodash/get";
import { bool, string } from "prop-types";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { STATIC_KEYWORDS } from "../../../constants";
import { getAdSlots } from "../utils";

import "./dfp-component.m.css";

const DfpComponent = ({
  adStyleName = "",
  id,
  path = "",
  type = "",
  adSlotConfigName,
  showText = true,
  theme = "",
  outOfPage = false,
  lazyLoadRefreshAdUnit = true,
  noDivWrap = false,
}) => {
  const { ADVERTISEMENT } = STATIC_KEYWORDS;
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const adsConfig = get(qtState, ["config", "ads-config", "dfp_ads"], {});
  const pageType = get(qtState, ["pageType"], "");
  const {
    view_port_size_mapping,
    ad_unit: adUnit,
    sizes,
    ad_style_name,
  } = get(qtState, ["config", "ads-config", "slots", adSlotConfigName], {});
  const loadAdsSynchronously = get(adsConfig, ["load_ads_synchronously"], null);
  const enableAds = get(adsConfig, ["enable_ads"], null);
  const currentPath = get(qtState, ["currentPath"], null);
  const delayAdLoad = get(adsConfig, ["delay_ad_load"], 4);
  if (!enableAds) {
    return null;
  }

  useEffect(() => {
    const slot = getAdSlots({
      path: path || adUnit,
      size: sizes,
      id,
      qtState,
      type,
      viewPortSizeMapping: view_port_size_mapping,
      loadAdsSynchronously,
      delayPeriod: delayAdLoad * 1000,
      outOfPage,
      lazyLoadRefreshAdUnit,
      noDivWrap,
    });

    return () => {
      if (slot && window.googletag?.destroySlots) {
        googletag.destroySlots([slot]);
      }
    };
  }, [currentPath, id, path]);

  if (outOfPage || noDivWrap) {
    return <div id={id} styleName={`${adStyleName || ad_style_name}`} />;
  }
  return (
    <div styleName={`ad-wrapper ${theme}`} className="ad-wrapper">
      {showText && (
        <p styleName="ad-text" className="ad-text trinity-skip-it">
          {ADVERTISEMENT}
        </p>
      )}
      <div
        className="ad-slot-container"
        styleName={`ad-slot ${adStyleName || ad_style_name} ${
          pageType === "story-page" &&
          (adStyleName === "ad-slot-size-728x90-300x250" || adStyleName === "ad-slot-size-728x90-320x50")
            ? "story-ad-container"
            : ""
        }`}
        id={id}
      />
    </div>
  );
};

DfpComponent.defaultProps = {
  adStyleName: "",
  id: "",
  path: "",
  type: "",
  adSlotConfigName: "",
  showText: true,
  lazyLoadRefreshAdUnit: true,
  noDivWrap: false,
};
DfpComponent.propTypes = {
  adStyleName: string,
  id: string.isRequired,
  path: string,
  type: string,
  adSlotConfigName: string,
  showText: bool,
  theme: string,
  lazyLoadRefreshAdUnit: bool,
  noDivWrap: bool,
};

export { DfpComponent };
